import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
import QuizViewerLayout from "@/components/layout/QuizViewerLayout.vue";
import SuccessQuizResult from "@/components/quiz/SuccessQuizResult.vue";
import ChapterWideScreenMsg from "@/components/chapter/ChapterWideScreenMsg.vue";
import { Events } from "@/events/events";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
let SuccessQuizPlayer = class SuccessQuizPlayer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quizId", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "quizResultPercentage", void 0);
    _defineProperty(this, "minSuccessRate", void 0);
    _defineProperty(this, "quizSucceededMsg", void 0);
    _defineProperty(this, "quizFailedMsg", void 0);
    _defineProperty(this, "unAchievedExamQuizId", void 0);
  }
  get quizExamAccomplished() {
    return this.quizResultPercentage > -1;
  }
  onFooterBtnClick() {
    if (this.quizExamAccomplished) {
      open(`/export-success/${this.quizId}`, "_blank");
    } else {
      if (this.unAchievedExamQuizId) {
        trig(Events.LOAD_ETAPE, `chapitre${this.unAchievedExamQuizId}`);
      } else {
        WElMessage.showErrorMessage(this.$t('errors.default'));
      }
    }
  }
};
__decorate([Prop({
  required: true
})], SuccessQuizPlayer.prototype, "quizId", void 0);
__decorate([Prop({
  default: false
})], SuccessQuizPlayer.prototype, "canEdit", void 0);
__decorate([Prop({
  default: -1
})], SuccessQuizPlayer.prototype, "quizResultPercentage", void 0);
__decorate([Prop({
  default: 0
})], SuccessQuizPlayer.prototype, "minSuccessRate", void 0);
__decorate([Prop({
  default: ''
})], SuccessQuizPlayer.prototype, "quizSucceededMsg", void 0);
__decorate([Prop({
  default: ''
})], SuccessQuizPlayer.prototype, "quizFailedMsg", void 0);
__decorate([Prop({
  default: 0
})], SuccessQuizPlayer.prototype, "unAchievedExamQuizId", void 0);
SuccessQuizPlayer = __decorate([Component({
  components: {
    ChapterWideScreenMsg,
    QuizViewerLayout,
    SuccessQuizResult,
    StandardButton
  }
})], SuccessQuizPlayer);
export default SuccessQuizPlayer;